module.exports = __webpack_public_path__ + "static/media/mobile-auditorium.dc2a024e.jpg";